import React, { Component } from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"
import { Design, Share, Code } from "./../lib/icons"
import styled from "styled-components"
import AppPreview from "./../lib/AppPreview"

const FeaturedAppData = [
  {
    name: "Featured App 1",
    imageUrl: "https://cdn.dribbble.com/users/188232/screenshots/3010058/financial.png",
    appId: "userId1",
    description: "An example of a thing you can build with React Designer."
  },
  {
    name: "Featured App 2",
    imageUrl: "https://cdn.dribbble.com/users/188232/screenshots/3010058/financial.png",
    appId: "userId2",
    description: "An example of a thing you can build with React Designer."
  },
  {
    name: "Featured App 3",
    imageUrl: "https://cdn.dribbble.com/users/188232/screenshots/3010058/financial.png",
    appId: "userId3",
    description: "An example of a thing you can build with React Designer."
  }
]

const ThreeItems = styled.div`
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  > div {
    width: 33%;
    text-align: center;
    svg {
      fill: #fff;
      width: 40px;
      opacity: 0.6;
    }
    h4 {
      margin: 10px 0;
      font-size: 20px;
      letter-spacing: 0.5px;
    }
    p {
      margin: 0;
      font-size: 13px;
    }
    a {
      color: white;
      font-size: 13px;
    }
    > a {
      display: block;
    }
    p,
    a {
      font-size: 13px;
      line-height: 21px;
    }
  }
`

class IndexPage extends Component {
  componentDidMount() {
    this.initDesigner()
  }
  initDesigner = () => {
    if (!window.ReactDesigner) {
      setTimeout(this.initDesigner, 100)
    } else {
      var rootEl = document.getElementById("embed-root")
      var editor = window.ReactDesigner(rootEl, "static", "embed")

      editor.openProjectFromData(
        { name: "Test Embed Project" },
        {
          id: "-Kt4OapdGmcecSAxlHao",
          typeName: "CoreProjectNode",
          children: {
            "49683357": {
              typeName: "CoreViewNode",
              options: { name: "Top" },
              children: {
                "135b7dda": { referenceId: "135b7dda", typeName: "CoreNodeReference", order: 0 },
                "1dd64bbb": { referenceId: "1dd64bbb", typeName: "CoreNodeReference", order: 1 },
                "7c60c3f6": { referenceId: "7c60c3f6", typeName: "CoreNodeReference", order: 2 }
              },
              styles: {
                alignItems: "center",
                boxSizing: "border-box",
                flexDirection: "row-reverse",
                justifyContent: "space-evenly",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "relative",
                offset: "topLeft",
                height: 102.5,
                width: 100,
                x: 0,
                y: 0,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: true,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  c0e37aa5: {
                    color: { a: 0.5, b: 235, g: 138, r: 177 },
                    id: "c0e37aa5",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.64, b: 218, g: 142, r: 123 }
              }
            },
            "135b7dda": {
              typeName: "CoreViewNode",
              options: { name: "New Layer" },
              children: {},
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "relative",
                offset: "topLeft",
                height: 30,
                width: 30,
                x: 0,
                y: 0,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  "9cbe253a": {
                    color: { a: 0.5, b: 240, g: 98, r: 214 },
                    id: "9cbe253a",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.5, b: 0, g: 0, r: 0 }
              }
            },
            "139c2689": {
              typeName: "CoreViewNode",
              options: { name: "blue", order: "2" },
              children: {
                "69f361b5": { referenceId: "69f361b5", typeName: "CoreNodeReference", order: 0 }
              },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "br",
                position: "absolute",
                offset: "topLeft",
                height: 118.75,
                width: 126.25,
                x: 0,
                y: -118.75,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  dbd46557: {
                    color: { a: 0.5, b: 226, g: 206, r: 118 },
                    id: "dbd46557",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.27, b: 238, g: 167, r: 68 }
              }
            },
            "1dd64bbb": {
              typeName: "CoreViewNode",
              options: { name: "New Layer" },
              children: {},
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 0.71,
                pin: "tl",
                position: "relative",
                offset: "topLeft",
                height: 58.75,
                width: 17.578125,
                x: 0,
                y: 0,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: true,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  c2221639: {
                    color: { a: 0.68, b: 168, g: 38, r: 131 },
                    id: "c2221639",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.5, b: 0, g: 0, r: 0 }
              }
            },
            "5909c4a4": {
              typeName: "CoreTextNode",
              options: { name: "Title2", textContent: "TITLE" },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "relative",
                offset: "topLeft",
                height: 48,
                width: 328.75,
                x: 15,
                y: 16,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {},
                borders: {},
                color: { a: 1, b: 0, g: 0, r: 0 },
                fontFamily: "Open Sans",
                fontSize: "24",
                fontWeight: "500",
                lineHeight: -1,
                letterSpacing: "5.2",
                textAlign: "left",
                textDecorationLine: "none",
                backgroundColor: { a: 0, b: 0, g: 0, r: 0 },
                fontStyle: "normal"
              }
            },
            "65927a81": {
              typeName: "CoreTextNode",
              options: {
                name: "Moar text",
                order: "1",
                textContent: "More great text, yo! And some other cool stuff."
              },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "relative",
                offset: "topLeft",
                height: 60.75,
                width: 328.4669,
                x: 17.5,
                y: 0,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 19,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {},
                borders: {},
                color: { a: 1, b: 0, g: 0, r: 0 },
                fontFamily: "Open Sans",
                fontSize: "13",
                fontWeight: "normal",
                lineHeight: -1,
                letterSpacing: "",
                textAlign: "left",
                textDecorationLine: "none",
                backgroundColor: { a: 0, b: 0, g: 0, r: 0 },
                fontStyle: "normal",
                overflow: "visible"
              }
            },
            "69b38cf0": {
              typeName: "CoreScreenNode",
              options: { isRoot: true, name: "Screen 1" },
              children: {
                eade3e26: { referenceId: "eade3e26", typeName: "CoreNodeReference", order: 0 }
              }
            },
            "69f361b5": {
              typeName: "CoreViewNode",
              options: { name: "green" },
              children: {},
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "absolute",
                offset: "topLeft",
                height: 56.908333333333346,
                width: 54.22018348623854,
                x: -54.22018348623854,
                y: 62,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  bcfcdb67: {
                    color: { a: 0.5, b: 109, g: 241, r: 142 },
                    id: "bcfcdb67",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.84, b: 154, g: 243, r: 145 }
              }
            },
            "7c60c3f6": {
              typeName: "CoreViewNode",
              options: { name: "New Layer" },
              children: {},
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "center",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "relative",
                offset: "topLeft",
                height: 23.75,
                width: 143.75,
                x: 0,
                y: 0,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  a41ddd83: {
                    color: { a: 0.5, b: 245, g: 89, r: 190 },
                    id: "a41ddd83",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.5, b: 0, g: 0, r: 0 }
              }
            },
            "82a5bee4": {
              typeName: "CoreScreenNode",
              options: { name: "Screen 2" },
              children: {
                "49683357": { referenceId: "49683357", typeName: "CoreNodeReference", order: 0 },
                f50229e2: { referenceId: "f50229e2", typeName: "CoreNodeReference", order: 1 }
              }
            },
            b6f2b71a: {
              typeName: "CoreViewNode",
              options: { name: "green" },
              children: {},
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "br",
                position: "absolute",
                offset: "topLeft",
                height: 49.999999999999986,
                width: 49.999999999999986,
                x: 2.5,
                y: 2.5,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  "206b1026": {
                    color: { a: 0.5, b: 163, g: 248, r: 172 },
                    id: "206b1026",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.5, b: 117, g: 230, r: 115 }
              }
            },
            c791eb66: {
              typeName: "CoreViewNode",
              options: { name: "blue" },
              children: {
                b6f2b71a: { referenceId: "b6f2b71a", typeName: "CoreNodeReference", order: 0 }
              },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 0.48,
                pin: "br",
                position: "absolute",
                offset: "topLeft",
                height: "150",
                width: 150,
                x: -100,
                y: -98.75,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 10,
                marginRight: 10,
                marginTop: 10,
                marginBottom: 10,
                paddingTop: 20,
                paddingBottom: 20,
                paddingLeft: 20,
                paddingRight: 20,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  "1a43863c": {
                    color: { a: 1, b: 231, g: 183, r: 142 },
                    id: "1a43863c",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.84, b: 255, g: 214, r: 174 }
              }
            },
            cc159df4: {
              typeName: "CoreTextNode",
              options: { name: "Whatever", textContent: "WHATEVER" },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "absolute",
                offset: "topLeft",
                height: 30.5,
                width: 203.4669,
                x: 15,
                y: 16.5,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {},
                borders: {},
                color: { a: 1, b: 0, g: 0, r: 0 },
                fontFamily: "Saira",
                fontSize: "15",
                fontWeight: "300",
                lineHeight: "26",
                letterSpacing: "5.2",
                textAlign: "left",
                textDecorationLine: "none",
                backgroundColor: { a: 0, b: 0, g: 0, r: 0 },
                fontStyle: "normal"
              }
            },
            d43219f8: {
              typeName: "CoreViewNode",
              options: { name: "purple", order: "0" },
              children: {
                cc159df4: { referenceId: "cc159df4", typeName: "CoreNodeReference", order: 0 }
              },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "absolute",
                offset: "topLeft",
                height: 128.75,
                width: 100,
                x: 0,
                y: 313.5,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: true,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  "38d52f98": {
                    color: { a: 0.5, b: 245, g: 153, r: 210 },
                    id: "38d52f98",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.5, b: 255, g: 173, r: 242 },
                overflow: "visible"
              }
            },
            d9a03f51: { typeName: "CoreScreenNode", options: { name: "New Screen" }, children: {} },
            eade3e26: {
              typeName: "CoreViewNode",
              options: { name: "red" },
              children: {
                "139c2689": { referenceId: "139c2689", typeName: "CoreNodeReference", order: 2 },
                "5909c4a4": { referenceId: "5909c4a4", typeName: "CoreNodeReference", order: 0 },
                "65927a81": { referenceId: "65927a81", typeName: "CoreNodeReference", order: 1 },
                d43219f8: { referenceId: "d43219f8", typeName: "CoreNodeReference", order: 3 }
              },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "column",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "absolute",
                offset: "topLeft",
                height: 158.25,
                width: 100,
                x: 0,
                y: 0,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                widthPercent: true,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  "7c16ef5c": {
                    color: { a: 0.5, b: 170, g: 170, r: 243 },
                    id: "7c16ef5c",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.31, b: 38, g: 2, r: 208 },
                color: { a: 1, b: 187, g: 187, r: 201 },
                overflow: "visible"
              }
            },
            f50229e2: {
              typeName: "CoreViewNode",
              options: { name: "red" },
              children: {
                c791eb66: { referenceId: "c791eb66", typeName: "CoreNodeReference", order: 0 }
              },
              styles: {
                alignItems: "flex-start",
                boxSizing: "border-box",
                flexDirection: "row",
                justifyContent: "flex-start",
                display: "flex",
                opacity: 1,
                pin: "tl",
                position: "relative",
                offset: "topLeft",
                height: 225,
                width: 222.50000000000003,
                x: 16.25,
                y: 16.25,
                overflowX: "visible",
                overflowY: "visible",
                zIndex: 1,
                marginLeft: 15,
                marginRight: 15,
                marginTop: 15,
                marginBottom: 15,
                paddingTop: 20,
                paddingBottom: 20,
                paddingLeft: 20,
                paddingRight: 20,
                widthPercent: false,
                heightPercent: false,
                xPercent: false,
                yPercent: false,
                fills: {
                  da662fed: {
                    color: { a: 0.5, b: 113, g: 113, r: 224 },
                    id: "da662fed",
                    isEnabled: true
                  }
                },
                borders: {},
                backgroundColor: { a: 0.62, b: 65, g: 65, r: 197 },
                overflow: "visible"
              }
            }
          },
          name: "Untitled Project"
        }
      )
    }
    //ReactDesigner(rootEl, "live", "site")
  }
  render() {
    return (
      <div>
        <Helmet
          bodyAttributes={{ class: "home" }}
          title="React Designer | Prototype visually, then export to React."
          meta={[{ name: "description", content: "A prototyping tool that exports real code." }]}
        />
        <div
          className="content-wrapper"
          style={{ color: "#fff", textAlign: "center", paddingBottom: 150 }}
        >
          <h1 style={{ fontSize: 40, fontWeight: 100, paddingTop: 50, paddingBottom: 30 }}>
            Prototype visually, then export to React.
          </h1>
          {/*
          <ThreeItems>
            <div>
              <Design />
              <h4>Design</h4>
              <p>Animations and components.</p>
              <Link to="/learn">Watch the tutorial ›</Link>
            </div>
            <div>
              <Share />
              <h4>Share & Remix</h4>
              <p>
                <Link to="/learn">Discover projects</Link> to remix.
              </p>
              <p>Then share what you create!</p>
            </div>
            <div>
              <Code />

              <h4>Export</h4>
              <p>
                Export to a{" "}
                <Link to="https://github.com/facebookincubator/create-react-app">
                  Create React App
                </Link>
              </p>
              <p>project at any time.</p>
            </div>
          </ThreeItems>
          */}
          <p style={{ paddingTop: 60 }}>
            <span style={{ fontWeight: 600 }}>Try it out!</span> Click 'Run' to preview the app.
          </p>
        </div>
        <div style={{ background: "#fff", minHeight: 600 }}>
          <div className="content-wrapper">
            <div style={{ position: "relative" }}>
              <div
                id="embed-root"
                style={{
                  width: "100%",
                  height: 600,
                  background: "#fff",
                  border: "1px solid #ddd",
                  top: -100,
                  left: 0,
                  position: "absolute"
                }}
              />
            </div>
            <div style={{ paddingTop: 600 }} />
            {/*
            <div style={{display: "flex", justifyContent: "space-between" }}>
              <h4>Featured Apps</h4>
              <Link to="/apps" style={{ fontSize: 13 }}>
                See more apps ›
              </Link>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {FeaturedAppData.map((x, i) => (
                <div key={i} style={{ width: "calc(33% - 10px)" }}>
                  <AppPreview data={x} />
                </div>
              ))}
            </div>

            <div
              style={{
                marginTop: 100,
                marginBottom: 50,
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <h4>Contribute to React Designer</h4>
              <a href="https://github.com/ReactDesigner/ReactDesigner" style={{ fontSize: 13 }}>
                GitHub ›
              </a>
            </div>

            */}
          </div>
        </div>
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js